module.exports = __webpack_public_path__ + "static/media/mini-landscape.7e185785.png";